import {BrowserConsoleMessageIcon} from "@/components/transaction/BrowserConsoleMessageIcon.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {BrowserConsoleMessage} from "@/lib/types/transaction";

interface RCABrowserConsoleLogProps {
  logs: BrowserConsoleMessage[];
}

export const RCABrowserConsoleLog = ({logs}: RCABrowserConsoleLogProps) => (
  <UpErrorBoundary>
    <h5 className="mb-2">
      <strong>Browser Console Log</strong>
    </h5>
    <ul
      className="list-unstyled border rounded browser-console-output mb-4"
      style={{maxHeight: "250px", overflowY: "auto"}}
    >
      {logs.map((e, i) => (
        <li key={i} className={e.type}>
          <BrowserConsoleMessageIcon className="me-2" type={e.type} />
          <span>{e.message}</span>
        </li>
      ))}
    </ul>
  </UpErrorBoundary>
);
